// JWT工具类 - 用于解析JWT token
class JWTUtils {
  /**
   * 解析JWT token的payload部分
   * @param {string} token - JWT token
   * @returns {object|null} - 解析后的payload，失败返回null
   */
  static parsePayload(token) {
    try {
      if (!token) return null;
      
      // JWT格式: header.payload.signature
      const parts = token.split('.');
      if (parts.length !== 3) {
        return null;
      }
      
      // 解析payload部分（base64url解码）
      const payload = parts[1];
      const decoded = this.base64UrlDecode(payload);
      return JSON.parse(decoded);
    } catch (error) {
      return null;
    }
  }
  
  /**
   * 从JWT token中获取用户ID
   * @param {string} token - JWT token
   * @returns {number|null} - 用户ID，失败返回null
   */
  static getUserIdFromToken(token) {
    const payload = this.parsePayload(token);
    return payload ? payload.user_id : null;
  }
  
  /**
   * 检查JWT token是否过期
   * @param {string} token - JWT token
   * @returns {boolean} - true表示已过期，false表示未过期
   */
  static isTokenExpired(token) {
    const payload = this.parsePayload(token);
    if (!payload || !payload.exp) return true;
    
    const now = Math.floor(Date.now() / 1000);
    return now >= payload.exp;
  }
  
  /**
   * 检查JWT token是否即将过期（1小时内）
   * @param {string} token - JWT token
   * @returns {boolean} - true表示即将过期
   */
  static isTokenExpiringSoon(token) {
    const payload = this.parsePayload(token);
    if (!payload || !payload.exp) return true;
    
    const now = Math.floor(Date.now() / 1000);
    const oneHour = 60 * 60;
    return (payload.exp - now) < oneHour;
  }
  
  /**
   * 获取JWT token的过期时间
   * @param {string} token - JWT token
   * @returns {Date|null} - 过期时间，失败返回null
   */
  static getTokenExpiration(token) {
    const payload = this.parsePayload(token);
    if (!payload || !payload.exp) return null;
    
    return new Date(payload.exp * 1000);
  }
  
  /**
   * Base64URL解码
   * @param {string} str - 需要解码的字符串
   * @returns {string} - 解码后的字符串
   */
  static base64UrlDecode(str) {
    // 添加padding
    str += '='.repeat((4 - str.length % 4) % 4);
    // 替换URL安全的字符
    str = str.replace(/-/g, '+').replace(/_/g, '/');
    return atob(str);
  }
  
  /**
   * 验证JWT token格式
   * @param {string} token - JWT token
   * @returns {boolean} - true表示格式正确
   */
  static isValidFormat(token) {
    if (!token || typeof token !== 'string') return false;
    const parts = token.split('.');
    return parts.length === 3;
  }
}

export default JWTUtils;
